import { OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS } from 'global/constants';
import {
  ActivityOutcomes,
  PerformanceExpectationGroup,
} from '../../activity-outcomes.constants';
import { mapOutcomeToOption } from 'approot/shared/outcomes/outcome.utils';

/**
 * Build initial groups from saved activityOutcomes by resolving outcome ids
 * to full outcomes (with category) and splitting by Performance Expectation (PE) into one group per PE.
 * Uses parentOutcomeId when present to assign dimensions to the correct PE;
 * falls back to order-based grouping for legacy data without parentOutcomeId.
 *
 * @param activityOutcomes - The activity outcomes to build groups from.
 * @returns The groups of activity outcomes.
 */
function buildPerformanceExpectationGroups(
  activityOutcomes: ActivityOutcomes
): PerformanceExpectationGroup[] {
  const groups: PerformanceExpectationGroup[] = [];
  const peOutcomeIdToGroup: Record<number, PerformanceExpectationGroup> = {};
  let current: PerformanceExpectationGroup = {
    outcomes: {},
    questionTypes: [],
    cerTypes: [],
  };

  const pushCurrent = () => {
    const hasAny = Object.keys(current.outcomes).some(
      key => (current.outcomes[key] ?? []).length > 0
    );
    if (hasAny) groups.push(current);
  };

  for (const outcomeWrapper of activityOutcomes.outcomes) {
    const outcome = outcomeWrapper.outcome;
    const category = outcome.category;
    const parentOutcomeId = outcomeWrapper.parentOutcomeId ?? undefined;

    if (category === OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS) {
      pushCurrent();
      current = {
        outcomes: {
          [OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS]: [
            mapOutcomeToOption(outcome),
          ],
        },
        questionTypes: outcomeWrapper.questionTypes ?? [],
        cerTypes: outcomeWrapper.cerTypes ?? [],
      };
      peOutcomeIdToGroup[outcome.id] = current;
    } else if (category) {
      const targetGroup =
        parentOutcomeId != null && peOutcomeIdToGroup[parentOutcomeId]
          ? peOutcomeIdToGroup[parentOutcomeId]
          : current;
      const arr = targetGroup.outcomes[category] ?? [];
      targetGroup.outcomes[category] = [...arr, mapOutcomeToOption(outcome)];
    }
  }
  pushCurrent();
  return groups;
}

export default buildPerformanceExpectationGroups;
